// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1d92eyr0 {
  display: flex;
  align-items: center;
  text-align: center;
  gap: 10px;
}
._1d92eyr1 {
  color: #E2E2E2;
  border: 0.1px solid #E2E2E2;
  border-width: 0.1px;
  padding: 0 10px;
  width: 50px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb","sourcesContent":["._1d92eyr0 {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  gap: 10px;\n}\n._1d92eyr1 {\n  color: #E2E2E2;\n  border: 0.1px solid #E2E2E2;\n  border-width: 0.1px;\n  padding: 0 10px;\n  width: 50px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
